import React from 'react';

import Spinner from 'components/shared/Spinner';

class KitPanelStats extends React.Component {
  render() {
    const title = this.props.title;
    const data = this.props.data;

    return (
      <div>
        <h6 className="mt-0 mb-2">{title}</h6>
        <div>
          <h5>
            <i className="fa fa-shopping-cart" /> × <span style={{color: '#777'}}>
              {
                data !== undefined ? (
                  data.num_orders
                ) : (
                  <Spinner />
                )
              }
            </span>
          </h5>
        </div>
        <div>
          <h5>
            <i className="fa fa-list" /> × <span style={{color: '#777'}}>
              {
                data !== undefined ? (
                  data.num_items.shippable + " + " + data.num_items.not_shippable
                ) : (
                  <Spinner />
                )
              }
            </span>
          </h5>
        </div>
        <div>
          <h5>
            <i className="fa fa-gift" /> × <span style={{color: '#777'}}>{data !== undefined ? data.num_kits.shippable + " + " + data.num_kits.not_shippable : <Spinner />}</span>
          </h5>
        </div>
        <div>
          <h5>
            <i className="fa fa-user" /> × <span style={{color: '#777'}}>{data !== undefined ? data.num_students.shippable + " + " + data.num_students.not_shippable : <Spinner />}</span>
          </h5>
        </div>
      </div>
    );
  }
}

export default KitPanelStats;






// WEBPACK FOOTER //
// ./src/components/kits/overview/KitPanelStats.js